export const CYCLE_LIST_MAX_WIDTH = '720px';

export const CYCLE_LIST_MAX_WIDTH_LIGHTBOX = '820px';

export const CYCLE_PRICE_MAX_WIDTH = '400px';

export const CYCLE_PRICE_MAX_WIDTH_LIGHTBOX = '560px';

export const getCycleListMaxWidth = (isQuickPayLightbox?: boolean): string =>
  isQuickPayLightbox ? CYCLE_LIST_MAX_WIDTH_LIGHTBOX : CYCLE_LIST_MAX_WIDTH;

export const getCyclePriceMaxWidth = (isQuickPayLightbox?: boolean): string =>
  isQuickPayLightbox ? CYCLE_PRICE_MAX_WIDTH_LIGHTBOX : CYCLE_PRICE_MAX_WIDTH;
